import type { ReactNode } from 'react';

interface TextProps {
  children: ReactNode;
  as?: 'p' | 'span' | 'div';
  variant?: 'default' | 'muted' | 'faint' | 'inverse';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const variantClasses = {
  default: 'text-ink',
  muted: 'text-ink-muted muted',
  faint: 'text-ink-faint',
  inverse: 'text-ink-inverse',
} as const;

const sizeClasses = {
  sm: 'text-sm',
  md: 'text-base',
  lg: 'text-lg',
} as const;

export function Text({ children, as: Tag = 'p', variant = 'default', size = 'md', className = '' }: TextProps) {
  return (
    <Tag className={`font-ui leading-relaxed ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}>
      {children}
    </Tag>
  );
}
